import React, { useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import MemberFormModal from "../../../pages/Member/components/MemberFormModal";
import MemberService from "../../../services/member_service";
import { useTenant } from "../../../hooks/useTenant";
import { useMembers } from "../../../hooks/useMembers";
import { initialMemberValues } from "../../../models/member";

const GlobalCreateMemberAction = () => {
    const navigate = useNavigate();
    const { idTenant, user } = useTenant();
    const { addOrUpdateMember } = useMembers();
    
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const handleSave = async (formData) => {
        setIsSaving(true);
        try {
            const savedMember = await MemberService.save(formData, idTenant, user, []);
            toast.success("Membro criado com sucesso!");
            setIsModalOpen(false);
            
            // Atualiza o cache local de membros
            if (savedMember) {
                addOrUpdateMember(savedMember);
            }
            
            // Redireciona para o perfil do novo membro
            if (savedMember && (savedMember.memberNumber || savedMember.id)) {
                navigate(`/members/${savedMember.id}`);
            }
        } catch (error) {
            console.error("Erro ao salvar membro (Global):", error);
            toast.error(error.message || "Erro ao salvar o membro. Tente novamente.");
        } finally {
            setIsSaving(false);
        }
    };

    return (
        <React.Fragment>
            <div className="dropdown d-inline-block me-1">
                <button 
                    type="button" 
                    className="btn header-item noti-icon waves-effect"
                    onClick={toggleModal}
                    title="Adicionar Novo Cliente"
                >
                    <i className="mdi mdi-account-plus-outline text-white" style={{ fontSize: '24px' }}></i>
                </button>
            </div>

            {/* Modal reaproveitado */}
            <MemberFormModal
                isOpen={isModalOpen}
                toggle={toggleModal}
                memberData={initialMemberValues}
                onSave={handleSave}
                isSaving={isSaving}
            />
        </React.Fragment>
    );
};

export default GlobalCreateMemberAction;
